import type { CellContext, ColumnHelper, ColumnMeta } from '@tanstack/react-table';

/** Empty or whitespace-only names become undefined so they are omitted from Filter options. */
const nameForColumn = <T extends { name?: string }>(row: T): string | undefined => {
  const name = row.name;
  if (name === undefined || name === null) {
    return undefined;
  }
  return name.trim().length > 0 ? name : undefined;
};

export const nameAccessor = <T extends { name?: string }>(
  columnHelper: ColumnHelper<T>,
  header = 'Name',
  filterMeta: ColumnMeta<T, string>['filter'] = {},
) =>
  columnHelper.accessor((row) => nameForColumn(row), {
    id: 'name',
    header,
    sortingFn: 'text',
    sortUndefined: 1,
    filterFn: 'arrIncludesSome',
    enableHiding: false,
    size: 300,
    minSize: 200,
    meta: {
      tooltip: true,
      filter: { type: 'dropdown', placeholder: 'All blocks', ...filterMeta },
      dataCellClassName: 'text-sm leading-5 font-medium text-info-900',
    },
    cell: (cellContext: CellContext<T, string>) => (
      <span className={`pl-${cellContext.row.depth * 4}`} title={cellContext.getValue()}>
        {cellContext.getValue()}
      </span>
    ),
  });
